import LogoWithText from "~/branding/default/full-text-logo.svg";
import Logo from "~/branding/default/logo.svg";
import type { TenantDefinition } from "../types";

const defaultTenant: TenantDefinition = {
	id: "default",
	name: "uTranscribe",
	theme: "default",
	branding: {
		name: "uTranscribe",
		theme: "default",
		Logo,
		LogoWithText,
	},
};

export default defaultTenant;
